import React from 'react'

export default () => (
  <svg viewBox="0 0 18 18">
    <path fillRule="evenodd" clipRule="evenodd" d="M17 0H1C.448 0 0 .446 0 .997v15.956c0 .55.448.997 1 .997h8.63v-6.93H7.26V8.286H9.6V6.293a3.265 3.265 0 01.912-2.608 3.285 3.285 0 012.588-.983c.705 0 1.41.04 2.11.12v2.433h-1.44c-1.13 0-1.34.529-1.34 1.317v1.735h2.7l-.35 2.712h-2.35V18H17c.552 0 1-.447 1-.997V.997A.999.999 0 0017 0z"/>
  </svg>
)
